/**
 * The document view's numbers: how long after the last change a document is saved, the
 * layout a new document starts with, and how far a picture's handle moves before it is a drag.
 */
import type { PageLayout } from "@protocol/PageLayout";
import { NORMAL_MARGINS_MM } from "../../../state/documents";

/** How long after the last change a document is saved, in milliseconds. */
export const SAVE_AFTER_MS = 2000;

/** The layout a page has when it says none. */
export const DEFAULT_LAYOUT: PageLayout = { size: "a4", orientation: "portrait", margins: [...NORMAL_MARGINS_MM] };

/** A drag shorter than this (pixels) is a click. */
export const PICTURE_DRAG_PX = 3;
